/*
import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pmPhoneFormat]'
})
export class PhoneFormatDirective {
    private regex: RegExp = new RegExp(/^\d{3}-\d{3}-\d{4}$/g);

    constructor(private el: ElementRef, private renderer: Renderer2,private control: NgControl) {}

    @HostListener('blur') onBlur() {
        this.formatPhoneNumber();
    }

    @HostListener('focus') onFocus() {
        this.removeFormatting();
    }
    private formatPhoneNumber() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters first
        if (value.length === 10) {
            // Format only if there are exactly 10 digits
            value = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }

        // Set the formatted value to the input field
        this.renderer.setProperty(this.el.nativeElement, 'value', value);

        // Set the formatted value to the form control
        this.control.control?.setValue(value);
    }


    private removeFormatting() {
        let value = this.el.nativeElement.value.replace(/\D/g, '-'); // Remove all non-digit characters
        this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }


}
*/
import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[pmPhoneFormat]'
})
export class PhoneFormatDirective {
    private regex: RegExp = new RegExp(/^\d{3}-\d{3}-\d{4}$/g);

    constructor(private el: ElementRef, private renderer: Renderer2, private control: NgControl) {}

    // Listener for key inputs (replaces invalid characters as user types)
    @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
        this.enforceNumericInput();
    }

    @HostListener('blur') onBlur() {
        this.formatPhoneNumber();
    }

    @HostListener('focus') onFocus() {
        this.removeFormatting();
    }

    // Enforces that only numeric characters are allowed in the input
    private enforceNumericInput() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters
        this.renderer.setProperty(this.el.nativeElement, 'value', value); // Update input field
    }

    // Format phone number when input loses focus (on blur)
    private formatPhoneNumber() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove non-digit characters first
        if (value.length === 10) {
            // Format only if there are exactly 10 digits
            value = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        }

        // Set the formatted value to the input field
        this.renderer.setProperty(this.el.nativeElement, 'value', value);

        // Set the formatted value to the form control
        this.control.control?.setValue(value);
    }

    // Remove formatting when the user focuses on the input
    private removeFormatting() {
        let value = this.el.nativeElement.value.replace(/\D/g, ''); // Remove all non-digit characters
        this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }
}
